import { useMediaQuery } from '@mantine/hooks';
import { type Breakpoint } from '../../types/breakpoint';

const breakpointQueries: Record<Breakpoint, string> = {
    mobile: '(max-width: 48em)', // до sm
    tablet: '(min-width: 48em) and (max-width: 64em)', // sm до md
    desktop: '(min-width: 64em)', // от md
    xs: '(max-width: 30em)', // до xs
    sm: '(min-width: 30em) and (max-width: 48em)', // xs до sm
    md: '(min-width: 48em) and (max-width: 64em)', // sm до md
    lg: '(min-width: 64em) and (max-width: 74em)', // md до lg
    xl: '(min-width: 74em)', // от lg
};

export const useBreakpoint = (breakpoint: Breakpoint): boolean => {
    return useMediaQuery(breakpointQueries[breakpoint], undefined, {
        getInitialValueInEffect: false,
    });
};
